import ToggleText from "./toggleText";

export default ToggleText;